import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { VerificationDataPageSubmission } from "../../../Component/Model/Dto/VerificationAgency/VerificationDataPageSubmission";
import { DataPageSubmissionStatus, VaSubmissionTypes } from "../../../Component/Model/Enum/BEE123Enums";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { StringDateTimeHelper } from "../../../Component/Model/helpers";

interface IncomingDataPagesTableRow {
    id: number;
    companyName: string;
    registrationNumber: string;
    latestSubmission: string;
    status?: string;
    actionDate?: string
}


export interface IncomingDataPageTable {
    columns: Array<TableColumn>;
    rows: Array<IncomingDataPagesTableRow>;
}

function getActionColumns(item: VerificationDataPageSubmission.DataPagesSearchResult, onEdit: (certificateId: number) => void, status: DataPageSubmissionStatus,): ActionType[] {
    const actions: ActionType[] = [];
    actions.push(
        {
            key: item.id.toString(),
            label: status === DataPageSubmissionStatus.Pending ? 'Apply Action' : 'View',
            action: () => {
                onEdit(item.id);
            },
            icon: {
                color: 'info',
                name: status === DataPageSubmissionStatus.Pending ? 'rule' : 'visibility'
            }
        }
    );

    return actions;
}

export function DataPagesTableMapper(results: VerificationDataPageSubmission.DataPagesSearchResult[], submissionType: VaSubmissionTypes, status: DataPageSubmissionStatus, onEdit: (certificateId: number) => void): IncomingDataPageTable {
    const latestSubmissionHeading = submissionType === VaSubmissionTypes.Submit_for_Verification ? 'Latest Submission' : 'Latest Request';
    const columns = [
        { Header: 'Company Name', accessor: 'companyName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        { Header: 'Registration Number', accessor: 'registrationNumber', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        { Header: latestSubmissionHeading, accessor: 'latestSubmission', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
    ];

    if (status !== DataPageSubmissionStatus.Pending) {
        const actionDateHeading = status === DataPageSubmissionStatus.Accepted ? 'Accepted On' : 'Rejected On';
        if (status === DataPageSubmissionStatus.Accepted) {
            columns.push(
                { Header: 'Status', accessor: 'status', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
            )
        }
        columns.push(
            { Header: actionDateHeading, accessor: 'actionDate', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" />, disableSortBy: true },
        )
    }

    columns.push(
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    );

    if (results.length > 0) {
        const rows: IncomingDataPagesTableRow[] = results.map((item: VerificationDataPageSubmission.DataPagesSearchResult, index: number) => (
            {
                id: item.id,
                companyName: item.companyName,
                registrationNumber: item.registrationNumber,
                scorecardName: item.scorecardName,
                latestSubmission: StringDateTimeHelper(item.latestSubmission.toString(), true) ?? '',
                status: item.actionType,
                actionDate: item.actionDate != null ? (StringDateTimeHelper(item.actionDate.toString()) ?? '') : '',
                actions: getActionColumns(item, onEdit, status)
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}